/** Whether backend assigned a thread (required for `/broadcasting/auth` on stage). */
export function isValidWidgetThreadId(
  threadId: number | string | null | undefined,
): threadId is number | string {
  return threadId != null && Number(threadId) > 0;
}
